export const FAIL_CONNECTION = "FAIL_CONNECTION";
export const INIT_CONNECTION = "INIT_CONNECTION";
export const UPDATE_CONNECTION = "UPDATE_CONNECTION";
export const INIT_CHECK_CONNECTION = "INIT_CHECK_CONNECTION";
export const RESET_CONNECTION_STATUS = "RESET_CONNECTION_STATUS";
export const STOP_FETCHING = "STOP_FETCHING";
export const CONNECTION_FAILED = "CONNECTION_FAILED";

export function resetConnectionStatus() {
  return {
    type: RESET_CONNECTION_STATUS,
  };
}

export function setWifi(essid, password, serialNum) {
  return {
    type: INIT_CONNECTION,
    meta: {
      endpoint: "/installer/connect",
      method: "POST",
      body: {
        ssid: essid,
        password: password,
        type: "WIRELESS",
        serialNum: serialNum,
      },
      success: setWifiSuccess,
      error: setWifiFail,
    },
  };
}

export function setWired(serialNum) {
  return {
    type: INIT_CONNECTION,
    meta: {
      endpoint: "/installer/connect",
      method: "POST",
      body: {
        serialNum: serialNum,
        type: "WIRED",
      },
      success: setWifiSuccess,
    },
  };
}

export function checkWifi(serialNum) {
  return {
    type: INIT_CHECK_CONNECTION,
    meta: {
      endpoint: "/installer/connect?serial_number=" + serialNum,
      success: checkWifiSuccess,
      error: checkWifiFailure,
    },
  };
}

export function failWifi() {
  return {
    type: FAIL_CONNECTION,
  };
}

function setWifiSuccess(response) {
  if (response.status === "NO_CONTACT") {
    return {
      type: FAIL_CONNECTION,
    };
  }
  return {
    type: UPDATE_CONNECTION,
    payload: {
      ...response,
    },
  };
}

function setWifiFail() {
  return {
    type: FAIL_CONNECTION,
  };
}

function checkWifiSuccess(response) {
  if (response.message === "Connected via RepositInstall") {
    return {
      type: FAIL_CONNECTION,
    };
  }
  return {
    type: UPDATE_CONNECTION,
    payload: {
      ...response,
    },
  };
}

function checkWifiFailure() {
  return {
    type: STOP_FETCHING,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/connection.js